module.exports = __webpack_public_path__ + "img/ellipsis.95a944b6.svg";